module.exports = __webpack_public_path__ + "img/cross-black.d5184ace.svg";